import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';

import { valueAccessor } from '@helpers/angular.helper';

@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [valueAccessor(PhoneInputComponent)]
})
export class PhoneInputComponent implements ControlValueAccessor {
  @ViewChild('phoneInput') private phoneInput?: ElementRef<HTMLInputElement>;

  @Input() inputId: string = '';
  @Input() inputClass?: string;

  private phoneValue = '';
  private phonePrefix = '38';
  private onChange = (_: string | null) => { };

  onTouched = () => { };

  constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

  set phone(val: string | null) {
    this.phoneValue = val || '';
    this.onChange(val ? `${this.phonePrefix}${val}` : null);
  }

  get phone(): string | null {
    return this.phoneValue;
  }

  registerOnChange(fn: (val: string | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  writeValue(val: string | null): void {
    if (typeof val === 'string') {
      this.phoneValue = this.sanitizePhonePrefix(val);
    } else {
      this.phoneValue = '';
    }

    if (!this.phoneValue) {
      this.clearInput();
    }

    this.changeDetectorRef.markForCheck();
  }

  private sanitizePhonePrefix(val: string): string {
    if (val.startsWith(this.phonePrefix)) {
      return this.cutPrefix(val, this.phonePrefix);
    }
    if (val.startsWith(`+${this.phonePrefix}`)) {
      return this.cutPrefix(val, `+${this.phonePrefix}`);
    }

    return val;
  }

  private cutPrefix(phone: string, prefix: string) {
    return phone.substring(prefix.length);
  }

  private clearInput(): void {
    if (this.phoneInput) {
      this.phoneInput.nativeElement.value = '';
    }
  }
}
